export const INIT_TEAM_CONTEXT = "INIT_TEAM_CONTEXT";
export const INIT_TEAMS_CONTEXT_COMPLETE = "INIT_TEAMS_CONTEXT_COMPLETE";
export const SAVE_TEAM_CONTEXT = "SAVE_TEAM_CONTEXT";
export const SAVE_TEAM_CONTEXT_COMPLETE = "SAVE_TEAM_CONTEXT_COMPLETE";
export const UPDATE_TEAM_CONTEXT_PLAYER = "UPDATE_TEAM_CONTEXT_PLAYER";
export const UPDATE_TEAM_CONTEXT_PLAYER_COMPLETE =
	"UPDATE_TEAM_CONTEXT_PLAYER_COMPLETE";
export const REFRESH_TEAM_CONTEXT = "REFRESH_TEAM_CONTEXT";
export const REFRESH_TEAM_CONTEXT_COMPLETE = "REFRESH_TEAM_CONTEXT_COMPLETE";
